var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6581_14476)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.66699 9.99935H18.3337M1.66699 9.99935C1.66699 14.6017 5.39795 18.3327 10.0003 18.3327M1.66699 9.99935C1.66699 5.39698 5.39795 1.66602 10.0003 1.66602M18.3337 9.99935C18.3337 14.6017 14.6027 18.3327 10.0003 18.3327M18.3337 9.99935C18.3337 5.39698 14.6027 1.66602 10.0003 1.66602M10.0003 1.66602C12.0847 3.94798 13.2693 6.90938 13.3337 9.99935C13.2693 13.0893 12.0847 16.0507 10.0003 18.3327M10.0003 1.66602C7.91593 3.94798 6.73136 6.90938 6.66699 9.99935C6.73136 13.0893 7.91593 16.0507 10.0003 18.3327",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6581_14476"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default __webpack_public_path__ + "static/media/globe.ff7f948ef2b05ce7102a058eccc4cf85.svg";
export { ForwardRef as ReactComponent };